import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useActionItemsSidebar } from "./ActionItemsSidebarContext";

/**
 * Revalidate sidebar TO DO source counts on route change (not on mount).
 * The provider already loads on mount; this effect must not depend on the
 * refresh function identity or a successful fetch retriggers itself forever.
 *
 * @example
 * // Mount on /business/action-items → no extra fetch
 * // Navigate to /business/settings → one silent refresh
 */
const ActionItemsSidebarNavSync = () => {
  const location = useLocation();
  const { refreshActionItemsData } = useActionItemsSidebar();
  const refreshRef = useRef(refreshActionItemsData);
  refreshRef.current = refreshActionItemsData;
  const skipFirstPathEffectRef = useRef(true);

  useEffect(() => {
    if (skipFirstPathEffectRef.current) {
      skipFirstPathEffectRef.current = false;
      return undefined;
    }
    refreshRef.current({ silent: true }).catch(() => {});
    return undefined;
  }, [location.pathname]);

  return null;
};

export default ActionItemsSidebarNavSync;

